import { Link } from '@inertiajs/react'
import { Play, BarChart3, Mountain, FileText } from 'lucide-react'

interface Props {
  teamId: number | null
  weeklyTacticalTemplate: { id: number; name: string } | null
}

export default function QuickActions({ teamId, weeklyTacticalTemplate }: Props) {
  const meetingHref = teamId ? `/teams/${teamId}/start_meeting` : '/teams'
  const scoreboardHref = teamId ? `/teams/${teamId}/scoreboard` : '/teams'
  const rocksHref = teamId ? `/teams/${teamId}/rocks` : '/teams'
  const startLabel = weeklyTacticalTemplate
    ? `Start ${weeklyTacticalTemplate.name}`
    : 'Start Weekly Tactical'
  const meetingData =
    teamId && weeklyTacticalTemplate
      ? { agenda_template_id: weeklyTacticalTemplate.id }
      : undefined

  return (
    <section>
      <h2 className="text-base font-bold uppercase tracking-widest text-text-muted mb-4 font-sans">
        QUICK ACTIONS
      </h2>
      <div className="flex flex-wrap gap-4">
        <Link
          href={meetingHref}
          method={teamId ? 'post' : 'get'}
          data={meetingData}
          as="button"
          className="bg-pinnacle-red hover:bg-pinnacle-red/90 text-white rounded-xl p-6 flex items-center gap-4 transition-colors min-h-[44px]"
          style={{ flex: '2 1 280px', minWidth: 280 }}
        >
          <div className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
            <Play className="w-7 h-7 text-white" />
          </div>
          <div className="text-left">
            <p className="text-xl font-bold font-sans">{startLabel}</p>
            <p className="text-base text-text-on-dark">Launch your meeting now</p>
          </div>
        </Link>

        <Link
          href={scoreboardHref}
          className="bg-white hover:bg-gray-50 rounded-xl shadow-card border border-stone/10 p-5 flex items-center gap-3 transition-colors"
          style={{ flex: '1 1 180px', minWidth: 180 }}
        >
          <div className="w-11 h-11 rounded-lg bg-[#F8F9FA] flex items-center justify-center flex-shrink-0">
            <BarChart3 className="w-6 h-6 text-text-primary" />
          </div>
          <div>
            <p className="text-lg font-semibold text-text-primary font-sans">View Scoreboard</p>
            <p className="text-sm text-text-muted">Full metrics view</p>
          </div>
        </Link>

        <Link
          href={rocksHref}
          className="bg-white hover:bg-gray-50 rounded-xl shadow-card border border-stone/10 p-5 flex items-center gap-3 transition-colors"
          style={{ flex: '1 1 180px', minWidth: 180 }}
        >
          <div className="w-11 h-11 rounded-lg bg-[#F8F9FA] flex items-center justify-center flex-shrink-0">
            <Mountain className="w-6 h-6 text-text-primary" />
          </div>
          <div>
            <p className="text-lg font-semibold text-text-primary font-sans">My Rocks</p>
            <p className="text-sm text-text-muted">Quarterly priorities</p>
          </div>
        </Link>

        <Link
          href="/agenda_templates"
          className="bg-white hover:bg-gray-50 rounded-xl shadow-card border border-stone/10 p-5 flex items-center gap-3 transition-colors"
          style={{ flex: '1 1 180px', minWidth: 180 }}
        >
          <div className="w-11 h-11 rounded-lg bg-[#F8F9FA] flex items-center justify-center flex-shrink-0">
            <FileText className="w-6 h-6 text-text-primary" />
          </div>
          <div>
            <p className="text-lg font-semibold text-text-primary font-sans">Agenda Templates</p>
            <p className="text-sm text-text-muted">Agenda presets</p>
          </div>
        </Link>
      </div>
    </section>
  )
}
